import { ANGEL_COOKIE_DOMAIN, ANGEL_PREVIEW_COOKIE_DOMAIN } from '@/constants/cookies'
import { paths } from '@/constants/paths'
import { isProductionEnvironment } from '@/utils/environment-utils'

/**
 * Gets the cookie domain for the current environment.
 * Production: .angel.com
 * Preview: .angel-preview.com
 * Other (staging, localhost): undefined (host-only cookies)
 */
export const getCookieDomain = (): string | undefined => {
  if (isProductionEnvironment()) {
    return ANGEL_COOKIE_DOMAIN
  }

  try {
    const baseUrl = paths.getBaseURL()
    const url = new URL(baseUrl)
    if (url.hostname === 'angel-preview.com' || url.hostname.endsWith('.angel-preview.com')) {
      return ANGEL_PREVIEW_COOKIE_DOMAIN
    }
  } catch {
    // If URL parsing fails, fall back to undefined
  }

  // Staging, localhost, and other environments - no domain (host-only cookies)
  return undefined
}

/**
 * Returns cookie domain options object for spreading into cookie options.
 * Returns { domain: string, path: '/' } for production/preview, or { path: '/' } for other environments.
 */
export const getCookieDomainOptions = (): { domain: string; path: string } | { path: string } => {
  const domain = getCookieDomain()
  const defaultOptions = { path: '/' }
  return domain ? { ...defaultOptions, domain } : defaultOptions
}
